import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './LoginPage.css';

const API_URL = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000';

/** Public Seite /passwort-vergessen – fordert einen Reset-Link per E-Mail an (Spec §4.4). */
const PasswortVergessenPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [tenantSlug, setTenantSlug] = useState('');
  const [mandanten, setMandanten] = useState<{ slug: string; firmenname: string }[]>([]);
  const [laedt, setLaedt] = useState(false);
  const [meldung, setMeldung] = useState<string | null>(null);
  const [fehler, setFehler] = useState<string | null>(null);

  useEffect(() => {
    const hostname = window.location.hostname;
    if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
      const slug = hostname.split('.')[0];
      if (slug && slug !== 'www') setTenantSlug(slug);
    }
    axios.get(`${API_URL}/api/auth/mandanten-liste`).then(r => setMandanten(r.data)).catch(() => {});
  }, []);

  const absenden = async (ev: React.FormEvent) => {
    ev.preventDefault();
    setLaedt(true);
    setFehler(null);
    try {
      const body: Record<string, string> = { email };
      if (tenantSlug.trim()) body.tenant_slug = tenantSlug.trim();
      const r = await axios.post(`${API_URL}/api/auth/passwort-vergessen`, body);
      setMeldung(r.data.message);
    } catch (e: any) {
      setFehler(e.response?.status === 429
        ? 'Zu viele Anfragen. Bitte eine Minute warten.'
        : (e.response?.data?.detail || 'Anfrage fehlgeschlagen.'));
    } finally {
      setLaedt(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-inner">
        <div className="login-frame">
          <span className="k-corner k-corner--tl">{'// kontor / passwort'}</span>
          <span className="k-corner k-corner--tr">erp.live</span>
          <span className="k-corner k-corner--bl">verschlüsselt</span>
          <span className="k-corner k-corner--br">mandantengetrennt</span>
          {meldung ? (
            <div className="login-form">
              <h1 className="login-h1">E-Mail unterwegs</h1>
              <p className="login-hint">{meldung} Der Link ist eine Stunde gültig.</p>
              <div className="login-links"><a className="login-link" href="/">Zum Login</a></div>
            </div>
          ) : (
            <form className="login-form" onSubmit={absenden}>
              <h1 className="login-h1">Passwort vergessen</h1>
              <p className="login-hint">Wir schicken Ihnen einen Link, mit dem Sie ein neues Passwort festlegen.</p>
              <div className="login-field">
                <label>E-Mail</label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                       placeholder="name@firma.de" required autoFocus />
              </div>
              {mandanten.length > 1 && (
                <div className="login-field">
                  <label>Firma</label>
                  <select value={tenantSlug} onChange={e => setTenantSlug(e.target.value)}>
                    <option value="">— Firma wählen (optional) —</option>
                    {mandanten.map(m => <option key={m.slug} value={m.slug}>{m.firmenname}</option>)}
                  </select>
                </div>
              )}
              {fehler && <div className="login-error">{fehler}</div>}
              <button className="login-btn" type="submit" disabled={laedt}>
                {laedt ? 'Sende …' : 'Link anfordern'} <span className="arr">→</span>
              </button>
              <div className="login-links"><a className="login-link" href="/">Zurück zum Login</a></div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default PasswortVergessenPage;
